module.exports = __webpack_public_path__ + "img/geofisica_16-9_2880.29b4fdd9.jpg";